<script setup lang="ts">
import { AlertTriangle } from 'lucide-vue-next';
import { Button } from '@/components/ui/button';
import type { UnsavedInputAction } from '@/composables/inventory/useUnsavedInputGuard';

/* Shown in a bulk count or purchase when another farm is picked or the dialog is closed while something is typed. */
const props = defineProps<{ action: UnsavedInputAction['kind']; farmName: string }>();

const emit = defineEmits<{ confirm: []; keep: [] }>();
</script>

<template>
    <div class="flex flex-wrap items-center gap-3 rounded-lg border border-warning-300 bg-warning-50 px-4 py-3" role="alert">
        <AlertTriangle class="size-5 shrink-0 text-warning-700" aria-hidden="true" />
        <span class="flex-1 text-normal text-gray-900">{{ $t(`views.health.inventory.unsavedInput.${props.action}.warning`, { farm: farmName }) }}</span>
        <div class="flex gap-2">
            <Button variant="outline" size="sm" @click="emit('keep')">{{ $t('views.health.inventory.unsavedInput.keep') }}</Button>
            <Button size="sm" @click="emit('confirm')">{{ $t(`views.health.inventory.unsavedInput.${props.action}.confirm`) }}</Button>
        </div>
    </div>
</template>
